import {connect} from 'react-redux';
import {Light as Component} from './Light';
import {
  createLight,
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {

  if(state.notebook.protocolSection.scene.apparatus.hasOwnProperty("Light") &&
     state.notebook.protocolSection.scene.apparatus.Light.some(
       box => box.id === ownProps.id
     )
  ){
    return {
      id: ownProps.id,
      type: state.notebook.protocolSection.scene.apparatus.Light[ownProps.id-1].type,
      isOn: state.notebook.protocolSection.scene.apparatus.Light[ownProps.id-1].isOn,
    }
  } else {
    return {}
  }
}

function mapDispatchToProps(dispatch) {
  return {
    createLight: (data)=>{
      dispatch(createLight(data))
    },
  };
}

export const Light = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
